module.exports = __webpack_public_path__ + "static/media/bpause.761338ed.svg";